import settings from '../settings.js'

const $inject = ['$filter', 'SurveyService', 'UserService', '$ionicPopup', '$ionicLoading', '$http', 'ArticleService', '$timeout', '$ionicBody']

function CommonService(filter, SurveyService, UserService, ionicPopup, ionicLoading, http, ArticleService, timeout, ionicBody) {
    const log = [];

    this.shared = {};

    this.settings = {
        notifications: {
            token: '',
            enabled: true,
            news: true
        }
    };

    this.locationFailureCount = 0;

    this.fullPersonCategoryData = null;
    
    this.validUntilArray = null; //This is actually an object... :)

    this.serverReaderLocationData = [];

    this.locations = [];
    this.selectedLocation = null;

    this.targetReaderId = null;

    this.setSelectedLocation = (selectedLocation) => this.selectedLocation = selectedLocation;

    this.resetBeaconValues = () => {
        console.log(`[${performance.now()}] resetBeaconValues() called.`);

        this.serverReaderLocationData.forEach((readerData, key) => {
            this.serverReaderLocationData[key].accuracy = null;
            this.serverReaderLocationData[key].rssi = null;
            this.serverReaderLocationData[key].tx = null;
        });
    };        

    this.openUrl = function (site, execScript) {
        if (!site) {
            this.writeToServerErrorLog('logTypeMisc', "Inappbrowser error. openUrl function received an invalid site url: " + site);

            const popupPromise = ionicPopup.alert({
                title: _locale('error opening page').ucfirst(),
                template: _locale('invalid link').ucfirst(),
                cssClass: 'bigger-popup'
            });

            this.ionicPopupHandler(popupPromise, 3000);

            return false;
        }

        const open = typeof cordova !== 'undefined' ? cordova.InAppBrowser.open : window.open,
            options = {
                location: 'yes',
                zoom: 'no'
            },
            target = site ? site : '_blank',
            executeScript = typeof execScript === 'object' ? execScript : false;

        // if the site is a key in the viewer setting
        if (!!settings.viewer && settings.viewer[site])
            site = settings.viewer[site];

        // always use login data when the site is on trusted domain
        if (site.indexOf(settings.domain) > -1 && UserService.loginData.loginState === 2)
            site += (site.indexOf('?') < 0 ? '?' : '&') + 'appauth=' + settings.appAuthSecret;

        open(site, target, $.param(options).replace(/\&/g, ','));
    };

    this.log = (message, logConsoleAlso = false) => {
        if (logConsoleAlso)
            console.log(`[${performance.now()}] Log:`, message);

        log.push({
            message: message ? filter('json')(message) : message,
            timestamp: Date.now()
        });
    };

    this.getLog = () => log;

    this.openSurvey = (hash, scope, filterName = false) => {
        ArticleService.getArticleSurvey(hash, (data) => {
            scope.survey = data;
            
            if (filterName && UserService.loginData.loginState === 2 && settings.supportSurveyData.custSupportSurvey.contactQuestionId) //If logged in, strip user name/email question from survey.
                scope.survey.elements = scope.survey.elements.filter((element) => element.questionId !== settings.supportSurveyData.custSupportSurvey.contactQuestionId);

                //Recreate survey to reset
                scope.createSurveyModal().then(() => {
                    scope.surveyModal.show();
                });
        });
    };

    this.getBasicSurveySave = (scope, modalName) => {
        SurveyService.baseUrl = settings.baseUrl;

        return (data) => {
            const popup = {
                template: '<p>' + (typeof scope.survey.settings.thankYouMessage !== 'undefined' ? scope.survey.settings.thankYouMessage : _locale('thank you for participating').ucfirst() + '!') + '</p>',
                title: scope.survey.surveyName,
                scope: scope,
                buttons: [{ text: 'OK' }]
            };

            const callback = (response) => {
                if (response.success) {
                    const popupPromise = ionicPopup.show(popup);

                    popupPromise.then(() => {
                        if (data.answers['q-' + settings.supportSurveyData.custSupportSurvey.selectQuestionId] && data.answers['q-' + settings.supportSurveyData.custSupportSurvey.selectQuestionId].value)
                            data.answers['q-' + settings.supportSurveyData.custSupportSurvey.selectQuestionId].value = "Asiakaspalaute";

                        if (data.answers['q-' + settings.supportSurveyData.custSupportSurvey.textQuestionId] && data.answers['q-' + settings.supportSurveyData.custSupportSurvey.textQuestionId].value)
                            data.answers['q-' + settings.supportSurveyData.custSupportSurvey.textQuestionId].value = "";

                        if (UserService.loginData.loginState !== 2 && settings.supportSurveyData.custSupportSurvey.contactQuestionId && data.answers['q-' + settings.supportSurveyData.custSupportSurvey.contactQuestionId] && data.answers['q-' + settings.supportSurveyData.custSupportSurvey.contactQuestionId].value)
                            data.answers['q-' + settings.supportSurveyData.custSupportSurvey.contactQuestionId].value = "";

                        if (!!modalName)
                            scope[modalName].hide();
                    });

                    this.ionicPopupHandler(popupPromise, 3000);
                }
                else {
                    popup.template = '<p>' + _locale(response.error).ucfirst() + '</p>';
                    const popupPromise = ionicPopup.show(popup);
                    this.ionicPopupHandler(popupPromise, 3000);
                }
            };

            SurveyService.saveSurveyAnswers(scope.survey.surveyId, data, callback, mutateUrl);

            function mutateUrl(url) {
                return url + '&appauth=' + settings.appAuthSecret;
            }
        };
    };

    this.saveSettings = (updateServer = true) => {
        if (updateServer && UserService.loginData.loginState === 2) {
			UserService.binaryVersion = null;
            UserService.updateSettings(this.settings); //.then((response) => console.log("updateSettings done"));
        }

        localStorage.setItem('settings-' + settings.appId, JSON.stringify(this.settings));
    };

    if (localStorage.getItem('settings-' + settings.appId))
        this.settings = JSON.parse(localStorage.getItem('settings-' + settings.appId));

    this.isDebugUser = (debugLevel) => (UserService.loginData.loginState === 2 && settings.debugLevel >= debugLevel);

    //Write information to server error_log
    this.writeToServerErrorLog = (logType, messageText, messageObject) => {
        if ((!settings.debugLogTypes[logType] && logType !== 'always') || !messageText)
            return false;

        http({
            url: settings.baseUrl + '?action=writedebuglog&appauth=' + settings.appAuthSecret,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': true
            },
            data: {
                logMessageType: logType,
                logMessageText: messageText,
                logMessageObject: messageObject,
                logPersonId: (typeof UserService.user !== 'undefined' && typeof UserService.user.personId !== 'undefined' && UserService.user.personId !== null) ? UserService.user.personId : false,
                appVersion: settings.appVersion,
                sentTime: window.performance.now(),
				sendEmail: false
            }
        });
    };

    //Fetch location data, beacon data and other settings stuff from server
    this.getServerAppData = (showSpinner = false, isRefresh = false, sourceInterval = false) => { 
        return new Promise((resolve, reject) => {
            if (UserService.loginData.loginState === 0) {
                return reject({
                    error: "User not logged in.",
                    data: null
                });
            }

            if (showSpinner) {
                ionicLoading.show({
                    template: '<p>' + _locale('retrieving information').ucfirst() + '...</p><ion-spinner></ion-spinner>'
                });
            }

            //Called from successHandler
            const setLocations = (readerData) => {
                this.locations = [];

                readerData.forEach((element) => { 
                    //Check if element locationId already in this.locations?
                    const locationIndex = this.locations.findIndex((loc) => loc.locationId === element.locationId);

                    if (locationIndex === -1) {
                        this.locations.push({ //Add each distinct location once to this.locations[]
                            locationId: element.locationId,
                            locationName: element.locationName,
                            locationDescription: element.locationDescription,
                            locationSettings: element.locationSettings
                        });
                    }
                });

                //Select first location by default
                if (this.selectedLocation === null && this.locations[0])
                    this.setSelectedLocation(this.locations[0]);
            };

            const successHandler = (response) => {
                //validUntilArray is an array like this: validUntilArray[locationId][indexItems]. 
                //It contains all valid dates for all location as an array, but we only ever make use of indexItem 0 (for now atleast).
                //Set validUntilArray if we get new data, or if this was not called from an interval (not refresh update)
                if ((response.data.validUntilArray && response.data.validUntilArray.length !== 0) || !sourceInterval)
                    this.validUntilArray = response.data.validUntilArray ? response.data.validUntilArray : [];

                if (response.data.fullPersonCategoryData)
                    this.fullPersonCategoryData = response.data.fullPersonCategoryData;
                    
                if (response.data.readerLocationData && response.data.readerLocationData.length) {
                    this.serverReaderLocationData = response.data.readerLocationData;

                    this.resetBeaconValues();
                    setLocations(response.data.readerLocationData);

                    return resolve(true);
                }

                reject({
                    error: _locale('no location information was received from the server.').ucfirst(),
                    data: response.data
                });
            };

            const errorHandler = (response) => {
                reject({
                    error: _locale('error retrieving data from server.').ucfirst(),
                    data: response.data
                });
            };
            
            http({
                url: settings.baseUrl + '?controller=ajax&getaccesscontrolappdata=1&appauth=' + settings.appAuthSecret,
                method: 'POST',
                data: {
                    personId: UserService.user.personId,
                    isTagLoginCheck: true,
                    device: null, //No device for jumppakalenteri
                    isRefresh: isRefresh,
                    serverLog: (sourceInterval === false || (sourceInterval === true && settings.debugLogTypes.logTypeRefreshInterval === true)) ? true : false,
                    appVersion: settings.appVersion
                }
            }).then(successHandler).catch(errorHandler)
                .finally(() => {
                    if (showSpinner)
                        ionicLoading.hide();
                });
        });
    };

    //Get doors valid for current location.
    this.getDoorsForLocation = (isAdmin = false) => {
        const doorsAlreadyAdded = [];

        const doorsForLocation = this.serverReaderLocationData.filter((door) => {
            let doorAddedIndex = doorsAlreadyAdded.map((reader) => reader.readerId).indexOf(door.readerId);

            if (!door.readerSettings.appVisible)
                return false;

            //Hide doors where user has no access to.
            //let hasAccess = (category) => door.locationId === category.locationId && door.controllerId === category.controllerId && door.readerId === category.readerId;
            //let userHasDoorAccess = (isAdmin || (this.fullPersonCategoryData && this.fullPersonCategoryData.some(hasAccess)) ? true : false);

            let userHasDoorAccess = true; //Show all doors right now. What to do if no doors are valid? TODO

            if (userHasDoorAccess && doorAddedIndex === -1 && this.selectedLocation.locationId === door.locationId)
                return doorsAlreadyAdded.push(door);

            return false;
        });

        if (doorsForLocation.length) { //Sort doors by AccessControlReaders.settings.appOrder
            doorsForLocation.sort((doorA, doorB) => {
                if (doorA.readerSettings.appOrder === doorB.readerSettings.appOrder)
                    return 0;

                if ((!doorA.readerSettings.appOrder && doorB.readerSettings.appOrder) || (doorA.readerSettings.appOrder < doorB.readerSettings.appOrder))
                    return -1;

                if ((doorA.readerSettings.appOrder && !doorB.readerSettings.appOrder) || (doorA.readerSettings.appOrder > doorB.readerSettings.appOrder))
                    return 1;

                return 0;
            });
        }

        return doorsForLocation;
    };

    this.fixModalOpen = () => { //Remove modal-open and popup-open classes from body tag. Fixes ionic popup bug on PWA.
        //Not sure this is needed anymore, but I don't think it hurts?
        ionicBody.removeClass('modal-open');
        ionicBody.removeClass('popup-open');
    };

    this.ionicPopupHandler = (popupPromise, autoCloseSeconds = false) => {
        popupPromise.finally(this.fixModalOpen);

        if (autoCloseSeconds)
            timeout(popupPromise.close, autoCloseSeconds);
    };
}

CommonService.$inject = $inject

export default CommonService